var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { action: "Index", "asp-antiforgery": "false" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.search.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "searchcontainer" }, [
        _c("div", { staticClass: "search" }, [
          _c("img", {
            attrs: { src: require("../../static/shipment-search.png") },
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.id,
                expression: "id",
              },
            ],
            attrs: {
              name: "Id",
              type: "text",
              placeholder: "Enter consignment number",
              required: "",
            },
            domProps: { value: _vm.id },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.id = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("button", { staticClass: "ripple", attrs: { type: "submit" } }, [
            _vm._v("Track shipment"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.isLoading
        ? _c("div", [_vm._m(0)])
        : _vm.consignmentDetails
        ? _c(
            "div",
            { staticClass: "container page-content" },
            [
              _c("tracking-consignment", {
                attrs: { "consignment-detail": _vm.consignmentDetails },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loader" }, [
      _c("div", { staticClass: "loader__bar" }),
      _vm._v(" "),
      _c("div", { staticClass: "loader__bar" }),
      _vm._v(" "),
      _c("div", { staticClass: "loader__bar" }),
      _vm._v(" "),
      _c("div", { staticClass: "loader__bar" }),
      _vm._v(" "),
      _c("div", { staticClass: "loader__bar" }),
      _vm._v(" "),
      _c("div", { staticClass: "loader__ball" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }